// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__QKuQB","tab":"Tabs_tab__lPnjN","active":"Tabs_active__rjE0r"};